// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__6XwEh","subheader":"ReorderModal_subheader__27yGx","listWrap":"ReorderModal_listWrap__3LKfd"};